import Vue from 'vue'
// Import components
import './components'
import App from './App.vue'
// Import router
import router from './router'
// Import store
import store from './store'
// Import Plugins
import vuetify from './plugins/vuetify'
import './plugins/chartist'
// Import Javascript libraries
import Moment from 'moment'

Vue.config.productionTip = false

// Filters
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  value = value.toLowerCase()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return Moment(value).format('DD-MM-YYYY HH:mm')
  } else {
    return null
  }
})

Vue.filter('formatDateSmall', function (value) {
  if (value) {
    return Moment(value).format('DD-MM-YYYY')
  } else {
    return null
  }
})

// Vuetify theme
Vue.use(vuetify, {
  theme: {
    primary: '#638fff', // #E53935
    secondary: '#812E7E', // #FFCDD2
    accent: '#812E7E' // #3F51B5
  }
})

Vue.use(Moment)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
